export const truncateString = (str: string, max: number): string => {
  if (str.length <= max) {
    return str
  }

  const init = str.slice(0, max)
  const lastSpace = init.lastIndexOf(' ')
  const lastFullStop = init.lastIndexOf('.')
  const lastBreakpoint = Math.max(lastSpace, lastFullStop)
  const limit = lastBreakpoint === -1 ? max : lastBreakpoint
  return `${str.slice(0, limit).replace(/[.,;]$/, '')}…`
}

export const truncateMarkdown = (str: string, max: number): string => {
  const readMoreIndex = str.indexOf('<!-- read more -->')
  const limit = readMoreIndex === -1 ? max : readMoreIndex
  return truncateString(str, limit)
}
